/* eslint-disable no-console */
import React, { useState } from 'react';
import Datepicker from 'react-datepicker';
import { format, isValid, parse } from 'date-fns';
import IconCalendar from '../../files/calendar.svg';

const DatePicker = ({
  elementTitle = 'Filter by date',
  inputDateClassName = 'form__datepicker-input',
  showDatepickerTo = true,
  paramFromName = 'meta_d3',
  paramToName = 'meta_d4',
  paramFormat = 'dMMMyyyy',
  selectedFromDate = '',
  selectedToDate = '',
  placeholderTextFrom = 'From',
  placeholderTextTo = 'End',
  // react-datepicker props
  allowSameDay = true,
  calendarClassName = 'datepicker__wrapper',
  dateFormat = 'dd/MM/yyyy',
  dropdownMode = 'select',
  showMonthDropdown = true,
  showYearDropdown = true,
  selectsStart = true,
  selectsEnd = true,
  ...datepickerProps
}) => {
  const today = new Date();
  const initialStartDate = selectedFromDate
    ? parse(selectedFromDate, paramFormat, today)
    : null;
  const initialEndDate = selectedToDate
    ? parse(selectedToDate, paramFormat, today)
    : null;

  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);

  const startParamValue = isValid(startDate)
    ? format(startDate, paramFormat)
    : '';
  const endParamValue = isValid(endDate) ? format(endDate, paramFormat) : '';

  const handleChange = (date) => {
    if (isValid(date)) {
      setStartDate(date);
    }
  };

  // eslint-disable-next-line react/display-name
  const CustomInput = React.forwardRef((props, ref) => (
    <>
      <input ref={ref} type="text" aria-label={props.placeholder} {...props} />
      <IconCalendar
        focusable={false}
        width="24"
        height="24"
        className="icon-calendar"
      />
    </>
  ));

  const renderDatePickerEnd = (
    <>
      <Datepicker
        allowSameDay={allowSameDay}
        calendarClassName={calendarClassName}
        className={inputDateClassName}
        dateFormat={dateFormat}
        placeholderText={placeholderTextTo}
        showMonthDropdown={showMonthDropdown}
        showYearDropdown={showYearDropdown}
        dropdownMode={dropdownMode}
        selected={endDate}
        onChange={setEndDate}
        selectsEnd={showDatepickerTo ? showDatepickerTo : selectsEnd}
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        customInput={<CustomInput />}
        {...datepickerProps}
      />
      <input type="hidden" name={paramToName} value={endParamValue} />
    </>
  );

  return (
    <div className="form__datepicker margins-off">
      <div className="form__datepicker-header">{elementTitle}</div>
      <Datepicker
        allowSameDay={allowSameDay}
        calendarClassName={calendarClassName}
        className={inputDateClassName}
        dateFormat={dateFormat}
        placeholderText={placeholderTextFrom}
        showMonthDropdown={showMonthDropdown}
        showYearDropdown={showYearDropdown}
        dropdownMode={dropdownMode}
        selected={startDate}
        onChange={handleChange}
        selectsStart={showDatepickerTo ? showDatepickerTo : selectsStart}
        selectsEnd={!showDatepickerTo && selectsEnd}
        startDate={startDate}
        endDate={endDate}
        customInput={<CustomInput />}
        strictParsing={true}
        {...datepickerProps}
      />
      <input type="hidden" name={paramFromName} value={startParamValue} />
      {showDatepickerTo ? renderDatePickerEnd : null}
    </div>
  );
};

export default DatePicker;
